module.exports = __webpack_public_path__ + "static/media/play_video_nep.47b15e88.svg";